var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-tooltip',{attrs:{"value":_vm.text}},[_c('app-button',{attrs:{"value":_vm.name,"name":("action-" + _vm.name),"icon":_vm.icon,"icon-size":"1rem","icon-prefix":"far","disabled":_vm.disabled,"small":""},on:{"click":_vm.onBtnClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }